import { Trans } from 'react-i18next';
import styles from './spaceNameError.module.scss';

export const renderSpaceNameError = () => {
  return (
    <div className={styles.spaceNameErrorContainer}>
      <Trans
        i18nKey='limitation.errors.invalidSpaceName'
        components={{
          1: <span className={styles.bold} />,
          2: <span className={styles.danger} />
        }}
      />
    </div>
  );
};

export const renderStoreNameError = () => {
  return (
    <div className={styles.spaceNameErrorContainer}>
      <Trans
        i18nKey='limitation.errors.invalidStoreName'
        components={{
          1: <span className={styles.bold} />,
          2: <span className={styles.danger} />
        }}
      />
    </div>
  );
};
